/**
 * Частоты и сроки проверки связи (RP-UI-LINK, шаг 6) — один объект на приложение, а не россыпь констант по пакетам. Здесь только
 * то, что определяет, как часто и как быстро клиент узнаёт о связи: с нашим сервером, живым каналом и кассовым агентом. Опросы
 * данных экранов (журналы чеков, смены, доставки) — у своих экранов: это не проверка связи.
 */
export const HEALTH_TIMINGS = {
  /** Наш сервер: паузы между проверками доступности, мс — 1, 2, 4, 8, затем каждые 10 с (`ConnectionMonitor`). */
  serverCheckPausesMs: [1_000, 2_000, 4_000, 8_000, 10_000],
  /** Наш сервер: срок одной проверки — сервер, который молчит дольше, для кассы всё равно что недоступен. */
  serverCheckTimeoutMs: 10_000,
  /**
   * Наш сервер: окно «Восстанавливаем соединение» появляется, если связи нет дольше этого, серия сбоев подтверждена и человек ждёт
   * ответа на своё действие (`selectConnectionNeedsAttention`). Обрыв на несколько секунд, за который связь вернулась, окна не вызывает.
   * Отсчёт идёт только пока окно приложения на виду: сбои, накопившиеся в свёрнутом окне, при возврате окна не вызывают.
   */
  serverOverlayDelayMs: 10_000,
  /**
   * Наш сервер, продажа и окно оплаты (RP-SALE-FAST, К-110): сколько можно не получать ответов сервера, пока экран ждёт опрос (ход
   * оплаты читается раз в секунду), прежде чем строка связи скажет «обновлено N с назад». Запрос, который завис, итога не даёт до
   * 30–90 с — возраст последнего ответа виден раньше итога.
   */
  dataStaleAfterMs: 5_000,
  /** Строка связи внутри продажи: как часто пересчитываются «нет связи N с» и возраст данных. */
  linkTickMs: 1_000,
  /** Живой канал: паузы переподключения, мс — 1, 2, 4, 8, 16, 30 с и дальше по 30 с (разброс ±20 % добавляет канал). */
  liveBackoffMs: [1_000, 2_000, 4_000, 8_000, 16_000, 30_000],
  /** Кассовый агент: как часто ищем его, пока его нет. */
  agentSearchEveryMs: 3_000,
  /** Кассовый агент: как часто читаем кассу, пока агент на связи и ничего не выполняется (агент кэширует состояние на 2 с). */
  agentDeviceEveryMs: 5_000,
  /** Кассовый агент: как часто сверяем его журнал (неразобранные операции). */
  agentJournalEveryMs: 30_000,
  /** Кассовый агент: сколько связь может быть «потеряна», прежде чем окно скажет «не найден». */
  agentLostToMissingMs: 60_000,
} as const
